import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class LedgerJournalRule  {
    _originalTypeClassName = "zERP.BO.LedgerJournalRule";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
LedgerJournalRule.translate = translateService;
}
this.Entity = new Domain.AccountingBusinessEntity();
this.Accounts = [];
this.SourceJournal = new Domain.AccountingJournal();
this.TargetJournal = new Domain.AccountingJournal();
this.Id = null;
this.Name = null;
this.IsActive = false;
this.EntryType = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
IsActive:any;
EntryType:any;
Entity:any;
Ledger:any;
Accounts:any;
SourceJournal:any;
TargetJournal:any;
FiscalPeriod:any;
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setLedger = ($this, value) => {
var oldValue = $this.Ledger;
$this.Ledger = value;
if (value != null) {
}
}
static setAccounts = ($this, items) => {
                if (items == null) items = [];
                if ($this.Accounts == null) $this.Accounts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Accounts.length > 0) {
                    Domain.LedgerJournalRule.removeAccounts($this, $this.Accounts[0]);
                }

                Domain.LedgerJournalRule.addManyAccounts($this, copyItems);
            }
static addManyAccounts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.LedgerJournalRule.addAccounts($this, items[i]);
                }
            }
static addAccounts = ($this, item) => {
                if ($this.Accounts == null) $this.Accounts = [];
                if (item == null || $this.Accounts.indexOf(item) > -1) return;
                $this.Accounts.push(item);
}
static addRangeAccounts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.LedgerJournalRule.addAccounts($this, item));
            }
static removeAccounts = ($this, item) => {
                if ($this == null || $this.Accounts == null || $this.Accounts.indexOf(item) === -1) return;
                var _index = $this.Accounts.indexOf(item);
                $this.Accounts.splice(_index, 1);
}
static clearAccounts = ($this) => { $this.Accounts = null; }
static setSourceJournal = ($this, value) => {
var oldValue = $this.SourceJournal;
$this.SourceJournal = value;
if (value != null) {
}
}
static setTargetJournal = ($this, value) => {
var oldValue = $this.TargetJournal;
$this.TargetJournal = value;
if (value != null) {
}
}
static setFiscalPeriod = ($this, value) => {
var oldValue = $this.FiscalPeriod;
$this.FiscalPeriod = value;
if (value != null) {
}
}

static GetDescription($this: any): any{if ($this?.Ledger == null || $this?.SourceJournal == null || $this?.TargetJournal == null) {return "";}
let entryType = "";
switch ($this?.EntryType) {case Domain.GeneralJournalType.Transaction:
{
entryType = "a Transaction";break;
}
case Domain.GeneralJournalType.Opening:
{
entryType = "an Opening";break;
}
case Domain.GeneralJournalType.Adjusting:
{
entryType = "an Adjusting";break;
}
case Domain.GeneralJournalType.Closing:
{
entryType = "a Closing";break;
}
}
return "When " + entryType + " entry is added on Ledger's '" + $this?.Ledger?.Name + "' Journal '" + $this?.SourceJournal?.Name + "', automaticcaly create an entry on Journal '" + $this?.TargetJournal?.Name + ".";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}